import Filter from './Filter';

new Filter();
